import { Modal, Button, Form } from "react-bootstrap";
import { useEffect, useState } from "react";
import { fetchWithAuth } from "../api/fetchWithAuth";

const initialForm = {
  number: "",
  name: "",
  category: "SW",
  sil: "",
  note: ""
};

const categoryOptions = [
  { value: "SW", label: "SW" },
  { value: "SWext", label: "SWext" },
  { value: "HW", label: "HW" },
  { value: "mechanical", label: "Mechanical" },
  { value: "definition", label: "Definition" },
  { value: "informative", label: "Informative" },
  { value: "others", label: "Others" }
];

function SystemRequirementFormModal({ show, onClose, onSaved, requirement }) {
  const isEdit = Boolean(requirement);
  const [form, setForm] = useState(initialForm);

  useEffect(() => {
    if (requirement) {
      setForm({
        number: requirement.number ?? "",
        name: requirement.name ?? "",
        category: requirement.category ?? "SW",
        sil: requirement.sil ?? requirement.SIL ?? "",
        note: requirement.note ?? ""
      });
    } else {
      setForm(initialForm);
    }
  }, [requirement, show]);

  const handleChange = (event) => {
    const { name, value } = event.target;

    setForm((current) => ({
      ...current,
      [name]: value
    }));
  };

  const handleSubmit = async () => {
    const url = isEdit
      ? `/api/system-requirements/${requirement.id}`
      : "/api/system-requirements";
    const method = isEdit ? "PUT" : "POST";

    const res = await fetchWithAuth(url, {
      method,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(form)
    });

    if (!res.ok) {
      const error = await res.json().catch(() => null);
      alert(error?.error || "Save failed");
      return;
    }

    onSaved();
    onClose();
  };

  return (
    <Modal show={show} onHide={onClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          {isEdit ? "Edit System Requirement" : "Add System Requirement"}
        </Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Number</Form.Label>
            <Form.Control name="number" value={form.number} onChange={handleChange} />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Name</Form.Label>
            <Form.Control
              as="textarea"
              rows={3}
              name="name"
              value={form.name}
              onChange={handleChange}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Category</Form.Label>
            <Form.Select
              name="category"
              value={form.category}
              onChange={handleChange}
              required
            >
              {categoryOptions.map((option) => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>SIL</Form.Label>
            <Form.Control name="sil" type="number" value={form.sil} onChange={handleChange} />
          </Form.Group>

          <Form.Group>
            <Form.Label>Note</Form.Label>
            <Form.Control
              as="textarea"
              rows={4}
              name="note"
              value={form.note}
              onChange={handleChange}
            />
          </Form.Group>
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancel
        </Button>
        <Button variant="success" onClick={handleSubmit}>
          Save
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default SystemRequirementFormModal;
